import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { InputGroup, Form } from 'react-bootstrap';
import y from 'y4/Utils';

function FileUpload({ field, name, onChange }) {
  const [fileName, setFileName] = useState('');
  const handleAddAttachment = files => {
    if (files.length === 0) return;
    setFileName(files[0].name);
    onChange({ name, value: files[0] });
  };

  return (
    <>
      <Form.Control readOnly value={fileName} />
      <InputGroup.Text>
        <Form.Label className="m-0 p-0">
          <Form.Control
            type="file"
            className="d-none"
            accept={y.gpv(field, 'other.file.accept')}
            multiple={y.gpv(field, 'other.file.multiple')}
            onChange={({ target }) => handleAddAttachment(target.files)}
          />
          {y.gpv(field, 'other.file.buttonTitle')}
        </Form.Label>
      </InputGroup.Text>
    </>
  );
}

FileUpload.propTypes = {
  dataCode: PropTypes.string,
  name: PropTypes.string,
  field: PropTypes.object,
  row: PropTypes.object, //used to show in grid
  onChange: PropTypes.func
};

export default FileUpload;
